<template>
    <div class="box">
        <el-form :model="myObj" label-width="auto">
            <el-form-item label="搜索文案">
                <el-input v-model="myObj.params.text"></el-input>
            </el-form-item>

            <el-form-item label="文字位置">
                <el-radio-group v-model="myObj.params.text_position">
                    <el-radio label="left">居左</el-radio>
                    <el-radio label="center">居中</el-radio>
                </el-radio-group>
            </el-form-item>

            <div class="color-box">
                <el-color-picker class="color-wrapper" v-model="myObj.params.text_color">
                </el-color-picker>
                <p>文字颜色{{ myObj.params.text_color }}</p>
            </div>

            <el-form-item label="展示按钮">
                <el-radio-group v-model="myObj.params.show_button">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="按钮文字">
                <el-input v-model="myObj.params.button_text"></el-input>
            </el-form-item>

            <div class="color-box" v-if="myObj.params.show_button == 1">
                <el-color-picker class="color-wrapper" v-model="myObj.params.button_color">
                </el-color-picker>
                <p>按钮颜色{{ myObj.params.button_color }}</p>
            </div>

        </el-form>

    </div>
</template>

<script>
export default {
    name: "SearchBarProp",
    components: {
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj
        }
    },
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}

.color-wrapper {
    width: 80%;
    height: 50px;
    margin-left: 10%;
}

:deep( .el-color-picker) {
    width: 80%;
    height: 50px;
}

:deep(.el-color-picker__trigger) {
    width: 100%;
    height: 100%;
    padding: 0;
}

.color-box {
    text-align: center;

    p {
        color: gray;
        font-size: small;
    }
}
</style>